// Time constants in milliseconds
export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const FIVE_MINUTES = ONE_MINUTE * 5;
export const THIRTY_MINUTES = ONE_MINUTE * 30;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;

// Shared delay for short route loading overlays (e.g., puzzle URL guard, Choose Game initial loader)
export const ROUTE_LOADER_DELAY_MS = 400;

const timeConstants = { ONE_SECOND, ONE_MINUTE, FIVE_MINUTES, THIRTY_MINUTES, ONE_HOUR, ONE_DAY, ROUTE_LOADER_DELAY_MS };
export default timeConstants;
